module.exports = __webpack_public_path__ + "static/media/bi_chat.f3cf62d9.svg";